module.exports = __webpack_public_path__ + "img/STRAT-alt.5921ca5b.svg";